<template>
  <div id="app">
    <!-- <div class="eyebrow" >
      Allegheny Mountain Collegiate Conference
    </div> -->

    <div class="logobar">
      <div class="logobar__inner">
        <img src="./assets/logos/site-logo.png" alt="Allegheny Mountain Collegiate Conference" class="site-logo" />
        <ul class="logos list-unstyled">
          <li v-for="c in channels"
            :key="c.id"
            class="logos__item">
            <a
            v-bind:class="'amcc-logo d-none d-md-block'"
            :href="'#/channels/'+c.id"
            :title="c.name">
              <span>{{c.name}}</span>
              <img v-bind:src="require('./assets/logos/' + c.abbrev + '-logo.png')" alt="" role="presentation" class="img-fluid" />
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="titlebar">
      <div class="container-fluid">
        <div class="row">
          <!-- <div class="col-6 text-left">
            Welcome to AMCC.tv
          </div> -->
          <div class="col-12">
            <a href="https://www.amccsports.org" target="_top">Return to AMCCSports.org</a>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid" style="min-height:calc(100vh - 365px)">
      <router-view/>
    </div>

    <div style="background: #fff; margin:50px 0 0 0;padding:30px 30px 0 30px;text-align:center;font-size:14px;line-height:14px;">
      <div class="row" style="align-items:center">
        <div class="col-sm-4 text-center text-sm-left" style="margin-bottom:30px">
          Allegheny Mountain Collegiate Conference<br>
          P.O. Box 180<br>
          North Boston, NY 14110<br>
          <!-- Office of the Commissioner: 413-572-8212<br> -->
          <!-- Office of Media Relations: 413-572-8449 -->
        </div>
        <div class="col-sm-4" style="margin-bottom:30px">
          Powered by &nbsp;
          <a href="https://www.boxcast.com" target="_blank">
            <img alt="BoxCast" src="https://cdn2.hubspot.net/hub/484866/file-2483746126-png/Logos/NewBoxCastLogo.png?t=1473431021465" style="height:14px;margin-top:-4px;">
          </a>
        </div>
        <div class="col-sm-4 text-center text-sm-right" style="margin-bottom:30px">
          <a href="http://www.ncaa.org/d3" target="_blank">
            <img
            src="https://cdn.prestosports.com/action/cdn/lc9mnf3yffjf1a7l/images/setup/2015/footer_logo_1.png" style="height:44px">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
export default {
  name: 'app',
  data () {
    return {
      channels: Config.staticChannels
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>

<style lang="scss">
@import "./styles/sprite.scss";
@import "./styles/main.scss";

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto 0;
  // box-shadow: 0 -10px 100px 20px rgba(0,0,0,0.5);
  // background: $blue-200;
}

.container-fluid {
  max-width: 1260px;
}

.ellipse, .jumbotron h1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-16-9 {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  background: black;
}

.fixed-16-9 > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 767px) {
  .col-sm-0 {
    display: none;
  }
}

#boxcast-container .boxcast-well {
  /* reset */
  border: none;
  box-shadow: none;
  text-align: left;
  padding: 0;
  margin: 0;

  /* clean */
  margin-top: 15px;
  padding: 15px;
}

body {
  background: no-repeat 50% 0 #243b81 url('https://d2o2figo6ddd0g.cloudfront.net/l/7/xnqgg42yexqzbu/page_bg.jpg');
  background-size: 2000px auto;
  font-family: 'Barlow', sans-serif;
}

a {
  color: $color-link-text-on-dark;

  &:hover {
    color: $color-link-text-on-dark;
  }
}

.card {
  background-color: #fff;
  border: 0;
  border-radius: 0;
}
.card-body {
  // background-color: #043562;
  color: #444;
}

.channel-nav {
  color: #043562;

  .card {
    border: 0;
  }
}
.list-group-item {
  background-color: $blue-400;
  color: $color-link-text-on-dark;
  margin-bottom: 5px;

  &:first-child, &:last-child {
    border-radius: 0;
  }
}
.list-group-item-action:focus, .list-group-item-action:hover {
  border-color: $gold;
  background-color: $gold;
  color: $blue-400;
}
.list-group-item.active {
  color: $blue-400;
  // box-shadow: inset 0px 0 0 3px $gray-100;
  background-color: #fff;
  border:0;
}

.boxcast-theme-dark .boxcast-well {
  background: #fff;
  color: #444;
}

.boxcast-title {
  font-family: 'Russo One', sans-serif;
  color: $blue-200;
  font-size: 24px;
}

.boxcast-boxoffice .boxcast-description {
  font-size: 18px;
  color: $blue-200;
  font-weight: 700;
  opacity: 1;
}

/* from sprite */
.eyebrow {
  background: $blue-600;
  color: #fff;
  padding: 10px;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.logobar {
  background: #FFF;
  zoom: .5;

  .logobar__inner {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1260px;
    margin: 0 auto;
    padding: 0 15px;
    height: 200px;
  }

  // @media screen and (min-width: 768px) {
  //   padding-top: 50px;
  // }

  @media (min-width: 768px) {
    zoom: 0.60;
    padding: 0 20px;

    .logobar__inner {
      height: auto;
    }
  }

  @media (min-width: 900px) {
    zoom: 0.70;
  }

  @media (min-width: 1000px) {
    zoom: 0.80;
  }

  @media (min-width: 1260px) {
    zoom: 1;
  }
}

.logos {
  display: none;

  @media screen and (min-width: 768px) {
    display: flex;
    flex-grow: 1;
    align-items: stretch;
    justify-content: space-around;
    margin: 0;
  }
}

.logos__item {
  border-right: 1px solid $gold;
  transform: skew(-12deg);
  padding: 8px 16px;
  flex: 1 0 0;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    transform: skew(12deg);
    transition: transform 100ms ease-in-out;

    &:hover {
      transform: skew(12deg) scale(1.05);
    }
  }
}

.titlebar {
  @include gold-gradient();
  text-align: center;
  color: $blue-200;
  font-weight: bold;
  padding: 15px;
  margin-bottom:35px;

  @media screen and (min-width: 768px) {
    // padding: 15px 0;
    text-align: right;
  }

  @media (min-width: 1260px) {
    padding: 24px 15px;
  }

  a {
    color: $blue-200;

    &:hover {
      color: $blue-200;
    }
  }
}

.site-logo {
  flex-shrink: 0;
  max-width: 175px;

  @media screen and (min-width: 768px) {
    margin-bottom: -60px;
  }
}

.amcc-logo {
  // display: inline-block;
  // margin-left: 20px;
  // flex-shrink: 0;
  width:100%;

  span {
      @include sr-only();
  }
}

// @include sprites($spritesheet-sprites);

// .amcc-logo.fitch {
//   width:67px;
//   margin-right:35px;
//   background-position:-100px -150px;
// }
// .amcc-logo.fram {
//   width:61px;
//   margin-right:34px;
//   background-position:-202px -150px;
// }
// .amcc-logo.mma {
//   width:67px;
//   margin-right:299px;
//   background-position:-297px -150px;
// }
// .amcc-logo.mcla {
//   width:80px;
//   margin-right:22px;
//   background-position:-663px -150px;
// }
// .amcc-logo.sal {
//   width:72px;
//   margin-right:35px;
//   background-position:-765px -150px;
// }
// .amcc-logo.west {
//   width:63px;
//   margin-right:21px;
//   background-position:-872px -150px;
// }
// .amcc-logo.wor {
//   width:81px;
//   background-position:-956px -150px;
// }

.btn {
  background-color: $gold;
  color: $blue-400;
  cursor: pointer;
  border-radius: 0;
  border: 0;
  font-weight: normal;
  font-family: 'Russo One', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-size: 16px;

  &:hover {
    background-color: lighten($gold, 8%);
    color: $blue-400;
  }
}

.dropdown-menu {
  border-radius: 0;
  border: 1px solid #fff;
  box-shadow: 0 7px 11px 0 rgba(0, 0, 0, 0.13), 0 2px 2px 0 rgba(0, 0, 0, 0.14901960784313725);
}

.dropdown-header {
  font-family: 'Russo One', sans-serif;
  font-weight: normal;
  color: $blue-200;
}

.dropdown-item.active, .dropdown-item:active {
  color: $blue-200;
  background: $gold;
}


.related-broadcasts [class*='col'] {
    margin-bottom: 12px;
}

.related-broadcasts > h4 {
  font-family: 'Russo One', sans-serif;
  text-align: left;
  margin-top: 0;
  font-size: 16px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue